module.exports = __webpack_public_path__ + "img/bg2.1b55f78c.png";